import {Api, ApiExport} from '../../Api.js'

const RESOURCE = 'schedule'

export default {
    resource: RESOURCE,
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    events(data) {
        return Api().post(this.resource + '/list', data)
    },
    closure(data) {
        return Api().post(this.resource + '/closures', data)
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    },
    export(period, date) {
        return ApiExport().get(this.resource + '/export?period=' + (period ? period : '') + '&date=' + date,
            {
                responseType: 'blob', // important
            });
    },
    getGoalCompletions(query) {
        return Api().get(this.resource + '/goals')
    },
    setOrderId(id, order_id, params) {
        return Api().post(this.resource  + '/' + id + '/set-order/' + order_id, params || {})
    },
    getStatsByUsers(period,branch,date=null) {
        return Api().get(this.resource + '/stats/users?period=' + period + '&date=' + date + '&branch=' + branch)
    },
}


// WEBPACK FOOTER //
// ./src/modules/agenda/AgendaService.js